import {Box, Button} from '@mui/material';
import React, {Fragment} from 'react';

import {BookingScheduledEnum} from 'main/analytics/gaTagsEnum';
import {AlertActions, AlertModal, DataInfo} from 'presentation/components';
import {OperationStateTypesEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {CancelDescription} from './components/CancelDescription';
import {useCancelBookingButton} from './hooks/useCancelBookingButton';
import {CancelBookingButtonProps} from './types';

const {cancelErrorAlert} = translations['pt-br'].privateFlow.myAppointments;
const {cancellationProtocol} =
	translations['pt-br'].privateFlow.myAppointments.myAppointmentDetails.appointmentInstructions;
const {cancelTitleModal} = translations['pt-br'].privateFlow.bookingFlow;
const {cancellation, close, confirmCancellation} = translations['pt-br'].commons;

export function CancelBookingButton({appointment}: CancelBookingButtonProps) {
	const {
		showCancelButton,
		isMobile,
		isSurgery,
		isDone,
		isError,
		isPending,
		isSubmitting,
		actionButtonText,
		errorBookingDialogTitle,
		successBookingDialogHeaderTitle,
		successBookingDialogTitle,
		handleCancelBooking,
		handleCloseSuccessDialogState,
		bookingData,
		setCancelState,
		bookingType,
	} = useCancelBookingButton(appointment);

	if (!showCancelButton) {
		return null;
	}

	return (
		<Fragment>
			<Button
				fullWidth={isMobile}
				size="large"
				color="error"
				variant="outlined"
				onClick={() => setCancelState(OperationStateTypesEnum.PENDING)}
				data-tag-id={BookingScheduledEnum.CLICK_CANCELAR_CONSULTA}>
				{actionButtonText()}
			</Button>

			<AlertModal
				headerDataTagId={BookingScheduledEnum.VISUALIZOU_MODAL_CANCELAR_AGENDAMENTO}
				closeBtnDataTagId={
					BookingScheduledEnum.CLICK_FECHAR_ICONE_MODAL_CANCELAR_AGENDAMENTO
				}
				subDescription={
					<CancelDescription
						appointment={appointment}
						multipleBooking={
							appointment.flExecutaSessao ? appointment.flExecutaSessao : false
						}
					/>
				}
				headerTitle={`${cancelTitleModal[bookingType as keyof typeof cancelTitleModal]}`}
				open={isPending || isSubmitting}
				onClose={() => setCancelState(OperationStateTypesEnum.NONE)}
				variant="info"
				footerContent={
					<AlertActions
						dataTagId={BookingScheduledEnum.CLICK_CONFIRMAR_CANCELAR_AGENDAMENTO}
						secondaryBtnDataTagId={
							BookingScheduledEnum.CLICK_FECHAR_BOTAO_MODAL_CANCELAR_AGENDAMENTO
						}
						isDisabled={isSubmitting}
						isLoading={isSubmitting}
						flexDirection="column-reverse"
						secondaryAction={() => setCancelState(OperationStateTypesEnum.NONE)}
						primaryAction={handleCancelBooking}
						secondaryBtnVariant="outlined"
						secondaryText={close}
						primaryText={confirmCancellation}
					/>
				}
			/>

			<AlertModal
				description={cancelErrorAlert.description}
				headerTitle={cancellation}
				title={errorBookingDialogTitle()}
				onClose={() => setCancelState(null)}
				open={isError}
				variant="info"
			/>

			<AlertModal
				subDescription={
					isSurgery ? null : (
						<Box alignSelf="center">
							<DataInfo
								primaryText={cancellationProtocol}
								secondaryText={bookingData.protocolNumber}
								iconName="assignment-filled"
							/>
						</Box>
					)
				}
				onClose={handleCloseSuccessDialogState}
				title={successBookingDialogTitle()}
				headerTitle={successBookingDialogHeaderTitle()}
				open={isDone}
				variant="success"
			/>
		</Fragment>
	);
}
